import { FC, useMemo } from "react";
import GenericBox from "components/ui/Box";
import { Layers } from "lucide-react";
import { NsKey } from "enums/NsKey";
import { useDynamicTranslation } from "hooks/useDynamicTranslation";

/** "A", "A et B", "A, B et C": the product labels in the order of the cards. */
export const joinProductLabels = (labels: string[], and: string): string => {
  if (labels.length <= 1) {
    return labels.join('');
  }
  return `${labels.slice(0, -1).join(', ')} ${and} ${labels[labels.length - 1]}`;
};

interface FormulasMessageProps {
  /** Labels of the products of the formula cards, in display order. */
  productLabels: string[];
}

/** Sentence above the formula cards: how many contracts can be subscribed together, and which. */
export const FormulasMessage: FC<FormulasMessageProps> = ({ productLabels }) => {
  const { t } = useDynamicTranslation([NsKey.Pricing]);

  const labels = useMemo(
    () => joinProductLabels(productLabels, t("PRICING.FORMULAS.AND")),
    [productLabels, t]
  );

  // Same frame as the insured person's box beside it, without the edit button.
  return (
    <GenericBox
      icon={Layers}
      title={t("PRICING.FORMULAS.TITLE")}
      subtitle={t("PRICING.FORMULAS.MESSAGE", { count: productLabels.length, labels })}
      className="grow"
    />
  );
};
